
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 42","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.719 21H16.26a.362.362 0 01-.257-.108.37.37 0 01-.107-.26v-1.474c0-.293-.116-.574-.321-.781a1.09 1.09 0 00-.773-.324h-2.188c-.29 0-.567.117-.772.324-.206.207-.32.488-.321.78v1.475a.37.37 0 01-.107.26.363.363 0 01-.258.108H9.698c-.29 0-.568.117-.773.324-.205.207-.32.488-.32.781v2.21c0 .294.115.575.32.782.205.207.483.324.773.324h1.458c.097 0 .19.039.258.108a.37.37 0 01.107.26v1.474c0 .293.115.574.32.781.206.207.484.324.774.324h2.187c.29 0 .568-.116.773-.324.205-.207.32-.488.32-.78V25.79a.37.37 0 01.108-.261.362.362 0 01.257-.108h1.459c.29 0 .568-.117.773-.324.205-.207.32-.488.32-.781v-2.21c0-.294-.115-.575-.32-.782a1.09 1.09 0 00-.773-.324z"}}),_c('path',{attrs:{"d":"M38.5 9.947c0-.781-.307-1.531-.854-2.084A2.901 2.901 0 0035.583 7H6.417c-.774 0-1.516.31-2.063.863A2.963 2.963 0 003.5 9.947v22.106c0 .781.307 1.531.854 2.084A2.901 2.901 0 006.417 35h29.166c.774 0 1.516-.31 2.063-.863a2.963 2.963 0 00.854-2.084V9.947zM7.146 32.053a.725.725 0 01-.516-.216.74.74 0 01-.213-.521V15.842a.74.74 0 01.213-.52.725.725 0 01.516-.217h27.708c.194 0 .379.078.516.216a.74.74 0 01.213.521v15.474a.74.74 0 01-.213.52.725.725 0 01-.516.217H7.146z"}}),_c('path',{attrs:{"d":"M31.573 20.631h-6.927c-.29 0-.568.117-.774.324a1.111 1.111 0 000 1.563c.206.207.484.324.774.324h6.927c.29 0 .568-.116.773-.324a1.111 1.111 0 000-1.563 1.088 1.088 0 00-.773-.323zM29.75 25.052h-5.104c-.29 0-.568.117-.774.324a1.111 1.111 0 000 1.563c.206.207.484.324.774.324h5.104c.29 0 .568-.117.773-.324a1.111 1.111 0 000-1.563 1.088 1.088 0 00-.773-.324z"}})])
          )
        }
      }
    